import React from 'react';
import PropTypes from 'prop-types';

export default function BranchIcon(props) {
  const { fill, width, height, className } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 16.754 16.231'
      className={className}
    >
      <g id='Grupo_12325' data-name='Grupo 12325' transform='translate(-327.678 -386.884)'>
        <rect
          id='Retângulo_1229'
          data-name='Retângulo 1229'
          width='2'
          height='5.144'
          transform='translate(336.723 393.157)'
          fill={fill}
        />
        <rect
          id='Retângulo_1230'
          data-name='Retângulo 1230'
          width='2'
          height='5.144'
          transform='translate(333.381 393.157)'
          fill={fill}
        />
        <rect
          id='Retângulo_1232'
          data-name='Retângulo 1232'
          width='2'
          height='5.144'
          transform='translate(340.066 393.157)'
          fill={fill}
        />
        <path
          id='Caminho_11756'
          data-name='Caminho 11756'
          d='M436.168,259.5l-7.868,5.255h15.736Z'
          transform='translate(-100.099 127.384)'
          fill={fill}
        />
        <path
          id='Caminho_11757'
          data-name='Caminho 11757'
          d='M441.283,304.7H428.3l-1.9,3.8h16.754Z'
          transform='translate(-98.722 94.619)'
          fill={fill}
        />
        <rect
          id='Retângulo_1233'
          data-name='Retângulo 1233'
          width='2'
          height='5.144'
          transform='translate(330.072 393.157)'
          fill={fill}
        />
      </g>
    </svg>
  );
}

BranchIcon.defaultProps = {
  fill: '#cacaca',
  width: 16.754,
  height: 16.231
};

BranchIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string
};
